module.exports = __webpack_public_path__ + "dashboard/img/copy.66f8d8e314b296843d2712929decae9f.svg";